import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=e2a88808"
import script from "./PaymentOrder.vue?vue&type=script&lang=ts"
export * from "./PaymentOrder.vue?vue&type=script&lang=ts"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=e2a88808&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports